<template>
  <v-card class="screen-height-container flex-content vh90">
    <v-card-title>
      <h2>Agrify SLA: {{value.label}}</h2>
      <v-spacer />
      <v-btn color="primary" @click="onNewTab" outlined>Open in New Tab</v-btn>
      <v-btn v-if="!showButton" @click="onClose" color="primary" outlined>Close</v-btn>
    </v-card-title>
    <v-card-text>
      <iframe
        frameborder="0"
        :src="value.url"
        style="border: 1px solid black; width: 100%; height:100%"
      />
    </v-card-text>
    <v-card-actions v-if="showButton" class="justify-center">
        <v-btn color="primary" @click="onAcknowledge">I have read and agree to the terms of this agreement</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SlaViewer",
  props: ["value", "showButton"],
  components: {},
  beforeMount() {

  },
  mounted() {},
  data() {
    return {
      rec: null
    };
  },

  computed: {
     ...mapGetters(["getUser"])
  },
  watch: {},
  methods: {
    onAcknowledge() {
      let me = this;
      let rec = {
        serviceLevelAgreement_id : this.value.id,
        users_id: this.getUser.id
      }
      Trimaster.post('serviceLevelAgreementAcceptances', this.getUser.apitoken, rec).then(function([res,err]) {
        if (err) {
          vuetifyToast.error("An error occurred. Please try again later.");
        }
        me.onClose();
      })

    },
    onClose() {
      this.$emit("close");
    },
    onNewTab() {
      window.open(this.value.url);
    }
  }
};
</script>
<style>
</style>
